(function (angular) {
  angular.module("app").directive("forumSearch", forumSearch);

  forumSearch.$inject = ["$window"];

  function forumSearch($window) {
    function link($scope) {
      // props.
      $scope.query = $scope.ngModel || "";
      $scope.showTips = false;
      $scope.rendered = "";
      // methods.
      $scope.search = search;
      $scope.renderQuery = renderQuery;
      $scope.toggleTips = toggleTips;

      function toggleTips() {
        $scope.showTips = !$scope.showTips;
      }

      function search() {
        $window.location.href = "/forum/search?q=" + $scope.query;
      }

      function renderQuery() {
        $scope.rendered = parseQuery($scope.query);
      }

      function parseQuery(query) {
        var BY_REGEX = /by:([a-zA-Z0-9_-]+)/,
          TAG_REGEX = /tagged:("?[a-zA-Z0-9-_\s]+"?)/,
          parts = query.match(/(?:[^\s"]+|"[^"]*"?)+/g),
          rendered = [];

        for (var index in parts) {
          var part = parts[index];

          if (BY_REGEX.test(part)) {
            rendered.push('<div class="forum-search-by">' + part + "</div>");
          } else if (TAG_REGEX.test(part)) {
            rendered.push(
              '<div class="forum-search-tagged">' + part + "</div>",
            );
          }
        }

        return rendered.join("");
      }

      $scope.rendered = parseQuery($scope.query);
    }

    return {
      link: link,
      restrict: "E",
      scope: {
        ngModel: "=",
        search: "=?",
      },
      templateUrl: "directives/forumSearch.html",
    };
  }
})(angular);
